import {
    PUSH_VIEW,
    POP_VIEW,
    REPLACE_VIEW,
    SET_ROOT_VIEW,
    REPLACE_ROOT_AND_CURRENT_VIEW,
    popView,
    pushView,
    replaceRootAndCurrentView,
    replaceView,
    setRootView,
} from './actions';

export const VIEWS_KEY = 'views';

export type View = {
    type: string;
    viewId: string;
};
export type ViewsState = {
    current?: View;
    previous?: ViewsState;
    transition?: 'push' | 'pop';
    transient?: boolean;
};

export type Action =
    | ReturnType<typeof popView>
    | ReturnType<typeof pushView>
    | ReturnType<typeof replaceRootAndCurrentView>
    | ReturnType<typeof replaceView>
    | ReturnType<typeof setRootView>;

export function viewsReducer(state: ViewsState = {}, action: Action): ViewsState {
    switch (action.type) {
        case PUSH_VIEW:
            return {
                current: action.view,
                previous: state.transient ? state.previous : state,
                transition: 'push',
                transient: action.transient,
            };

        case POP_VIEW:
            let previousView = state.previous;
            if (action.backToViewId) {
                while (previousView && previousView.current?.viewId !== action.backToViewId) {
                    previousView = previousView.previous;
                }
                if (previousView === undefined) {
                    // eslint-disable-next-line no-console
                    console.log('Unable to find viewId', action.backToViewId);
                }
            }
            return previousView ? { ...previousView, transition: 'pop' } : state;

        case REPLACE_VIEW:
            return {
                current: action.view,
                previous: state.previous,
                transition: 'push',
                transient: action.transient,
            };

        case SET_ROOT_VIEW:
            return {
                current: action.view,
                transition: 'push',
            };

        case REPLACE_ROOT_AND_CURRENT_VIEW:
            return {
                current: action.view,
                transition: 'push',
                previous: action.previous && {
                    current: action.previous,
                    transition: 'push',
                },
            };
        default:
            return state;
    }
}
